/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_OPENSANS_REGULAR: 'OpenSansRegular, sans-serif',
  FONT_WORKSANS_LIGHT: 'WorkSansLight, sans-serif',
  FONT_WORKSANS_REGULAR: 'WorkSansRegular, sans-serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_300: '300',
  //Mobile values
  //H1
  FONT_SIZE_H1: '36px',
  LINE_HEIGHT_H1: '40px',
  LETTER_SPACING_H1: 'normal',
  //H2
  FONT_SIZE_H2: '30px',
  LINE_HEIGHT_H2: '35px',
  LETTER_SPACING_H2: 'normal',
  //H3
  FONT_SIZE_H3: '24px',
  LINE_HEIGHT_H3: '26px',
  LETTER_SPACING_H3: 'normal',
  //H4
  FONT_SIZE_H4: '18px',
  LINE_HEIGHT_H4: '21px',
  LETTER_SPACING_H4: 'normal',
  //H5
  FONT_SIZE_H5: '12px',
  LINE_HEIGHT_H5: '20px',
  LETTER_SPACING_H5: 'normal',
  //P
  FONT_SIZE_P: '14px',
  LINE_HEIGHT_P: '22px',
  LETTER_SPACING_P: '0.3px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '50px',
    LINE_HEIGHT_H1: '60px',
    LETTER_SPACING_H1: 'normal',
    //H2
    FONT_SIZE_H2: '38px',
    LINE_HEIGHT_H2: '44px',
    LETTER_SPACING_H2: 'normal',
    //H3
    FONT_SIZE_H3: '26px',
    LINE_HEIGHT_H3: '30px',
    LETTER_SPACING_H3: 'normal',
    //H4
    FONT_SIZE_H4: '20px',
    LINE_HEIGHT_H4: '24px',
    LETTER_SPACING_H4: 'normal',
    //H5
    FONT_SIZE_H5: '14px',
    LINE_HEIGHT_H5: '16px',
    LETTER_SPACING_H5: 'normal',
    //P
    FONT_SIZE_P: '15px',
    LINE_HEIGHT_P: '24px',
    LETTER_SPACING_P: '0.3px'
  },
  FONT_FACES: ['OpenSansRegular', 'WorkSansLight', 'WorkSansRegular']
};